class HHZoomGallery extends HTMLElement {
  constructor() {
    super()

    this.currentSlideCountElement = this.querySelector('[data-current-slide-counter]');
  }

  connectedCallback() {
    this.init()
  }

  init() {
    this.swiper = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 1,
      navigation: {
        nextEl: this.querySelector('.swiper-nav-btn-next'),
        prevEl: this.querySelector('.swiper-nav-btn-prev'),
      },
      pagination: {
        el: this.querySelector('.swiper-pagination-bullets'),
        clickable: true,
      },
      zoom: true,
      on: {
        slideChange: () => {
          this.updateFraction()
          this.updateActiveSlideInteraction()
        },
      },
    });

    this.updateActiveSlideInteraction();
  }

  updateFraction() {
    if (!this.currentSlideCountElement) return
    this.currentSlideCountElement.textContent = this.swiper.activeIndex + 1
  }

  updateActiveSlideInteraction() {
    if (!this.swiper) return

    const activeSlide = this.swiper.slides[this.swiper.activeIndex]
    const isModelSlide = activeSlide?.dataset?.mediaType === 'model'

    this.swiper.allowTouchMove = !isModelSlide
  }
}

customElements.define('hh-zoom-gallery', HHZoomGallery)
